import { render, staticRenderFns } from "./findRelatedDocBtn.vue?vue&type=template&id=4ce090de&scoped=true"
import script from "./findRelatedDocBtn.vue?vue&type=script&lang=js"
export * from "./findRelatedDocBtn.vue?vue&type=script&lang=js"
import style0 from "./findRelatedDocBtn.vue?vue&type=style&index=0&id=4ce090de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce090de",
  null
  
)

export default component.exports